import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yx_icon_up",
  "use": "icon-yx_icon_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yx_icon_up\"><path d=\"M489.386667 361.386667a32 32 0 0 1 45.226666 0L813.226667 640 768 685.226667l-256-256-256 256L210.773333 640l278.613334-278.613333z\" p-id=\"1821\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgIcons/svg/yx_icon_up.svg
// module id = pj+x
// module chunks = 76